<div mat-dialog-content>
    <div class="mat-dialog-content">
        <div class="head-confirm-modal-list">
            <h2>{{this.title}}</h2>
        </div>
        <div class="body-confirm-modal-list">
            <div class="row">
                <div class="col-12">{{this.message}}</div>
            </div>
        </div>
        <div class="footer-confirm-modal-list">
            <button mat-flat-button color="primary" class="btn-block" (click)="clickPrimary()" type="button">
                <span>{{this.btnConfirm}}</span>
            </button>
            <button mat-flat-button color="accent" class="btn-block" (click)="clickAccent()" type="button">
                <span>{{this.btnDeny}}</span>
            </button>
        </div>
    </div>
</div>